import { ActionReducer, Action } from '@ngrx/store';
import { initialCompanyVoteProposalNameListState, ICompanyVoteProposalNameListState } from '../states/company-vote-proposal-name-list.state';
import { ECompanyVoteProposalNameListActions, SetSearchFilter, SetPagination, SetSort } from '../actions/company-vote-proposal-name-list.actions';
import { EActiveYearActions } from '../actions/active-year.actions';

export const companyVoteProposalNameListReducers: ActionReducer<ICompanyVoteProposalNameListState, Action<string>> = (
  state = initialCompanyVoteProposalNameListState,
  action: Action<string>
) => {
  switch (action.type) {
    case ECompanyVoteProposalNameListActions.SetSearchFilter: {
      const typedAction = action as SetSearchFilter;
      return {
        ...state,
        searchFilter: typedAction.payload,
        currentPage: 1
      };
    }

    case ECompanyVoteProposalNameListActions.SetPagination: {
      const typedAction = action as SetPagination;
      return {
        ...state,
        currentPage: typedAction.payload.currentPage,
        pageSize: typedAction.payload.pageSize
      };
    }

    case ECompanyVoteProposalNameListActions.SetSort: {
      const typedAction = action as SetSort;
      return {
        ...state,
        sortBy: typedAction.payload.sortBy,
        ascending: typedAction.payload.ascending
      };
    }

    case ECompanyVoteProposalNameListActions.ClearFilters: {
      return {
        ...initialCompanyVoteProposalNameListState
      };
    }

    case EActiveYearActions.Changed: {
      const { year: _dropped, ...rest } = state.searchFilter;
      return {
        ...state,
        searchFilter: rest
      };
    }

    default:
      return state;
  }
};
